import { render } from "./ReihenhausStep8b.vue?vue&type=template&id=7a721670&scoped=true"
import script from "./ReihenhausStep8b.vue?vue&type=script&lang=js"
export * from "./ReihenhausStep8b.vue?vue&type=script&lang=js"

import "./ReihenhausStep8b.vue?vue&type=style&index=0&id=7a721670&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a721670"]])

export default __exports__